/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Dropdown, Modal } from "react-bootstrap";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom"
import Card from "../Card";
import CPTCodeSelect from "../CPTCodeSelect";
import DiagCodeSelect from "../DiagCodeSelect";
import FormLabel from "../FormLabel";
import Icon from "../Icon";
import Patient from "../Patient";
import ProductList from "../ProductList";
import { withParamsAndNavigate } from "../WithParamsAndNavigate"
import Wound2 from "../Wound2";
import ClaimItemTable from "./ClaimItemTable";
import FormInput from "../FormInput";
import { Pop } from "../PopModal";
import Insurance from "../Insurance";
import { Link } from "react-router-dom";
import Switch from "../Switch";
import ClaimNotes from "./ClaimNotes";
import Globals from "../../shared/Globals";
import OptionButton from "../OptionButton";
import L from "../Lang";

class SplitModal extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                amount: 900000
            }
        }
    }

    split = () => {

    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title><L>Split Claim</L></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormInput model={this.state.info} name="amount" label="Amount" onChange={this.change} />
            </Modal.Body>
            <Modal.Body className="text-end">
                <button type="button" className="btn btn-success" onClick={this.split}><Icon icon="faArrowsSplitUpAndLeft" /> <L>Split</L></button>
                <button type="button" className="btn btn-secondary" onClick={this.props.onHide}><Icon icon="faCancel" /> <L>Cancel</L></button>
            </Modal.Body>
        </Modal>;
    }
}

class ClaimEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            claim: null,
            autoSave: false,
            errors: []
        }
    }

    async componentDidMount() {
        await this.getSettings();
        this.applyThemeColors();
        await this.loadConstraints();
        await this.loadPOSList();
        await this.loadAsync();
        await this.checkAutoSave();
    }

    async componentWillUnmount() {
        clearInterval(this.autoSaveTimer);
        if (this.state.autoSave)
            await this.submit(null, true);
    }

    checkAutoSave = async () => {
        try {
            let j = await qreq.getAsync('/api/claim/autosave/toggle/value');
            if (j.item) {
                this.toggleAutoSaveTimer(true);
                this.setState({ autoSave: true });
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    loadAsync = async () => {
        try {
            let j = await qreq.getAsync('/api/claim/' + this.props.params.id);
            if (j.item) {
                j.item.items.forEach(i => i.uuid = this.uuid());
                j.item.claims.forEach(i => {
                    i.uuid = this.uuid();
                    i.items.forEach(j => j.uuid = this.uuid());
                });
                this.setState({ claim: j.item });
                this.validateItemChanges(j.item.claims);
            }
            else if (j.errorCode)
                this.alert(j.errorMesage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    loadPOSList = async () => {
        try {
            let j = await qreq.getAsync('/api/claim/pos/list');
            if (j.list) {
                j.list.forEach(i => {
                    i.id = i.code;
                });
                this.setState({ posList: j.list });
            }
            else if (j.errorCode)
                this.alert(j.errorMesage);
        }
        catch (e) {
            console.error(e);
            this.unkownErrorCallback();
        }
    }

    addClaimItem = (childClaim, newItem) => {
        if (!newItem)
            newItem = {};
        newItem.id = 0;
        newItem.uuid = this.uuid();
        newItem.units = 1;
        newItem.modifiers = [];
        newItem.diagCodes = [];
        if (childClaim) {
            let claim = { ...childClaim };
            let items = claim.items;
            items.push(newItem);
            this.setState({ claim: { ...this.state.claim } });
            return;
        }
        let items = [...this.state.claim.items];

        items.push(newItem);
        this.setState({ claim: { ...this.state.claim, items: items } });
        this.touch();
    }

    onRemoveClaimItem = (idx, childClaim) => {
        Pop.showConfirm('Are you sure you want to remove this item?', 'Remove Item', () => {
            if (childClaim) {
                let claim = { ...childClaim };
                let items = claim.items;
                items.splice(idx, 1);
                this.setState({ claim: { ...this.state.claim } });
                this.touch();
                return;
            }
            let items = [...this.state.claim.items];
            items.splice(idx, 1);
            this.setState({ claim: { ...this.state.claim, items: items } });
            this.touch();
        });
    }

    addChildClaim = () => {
        let claims = this.state.claim.claims ?? [];
        claims.push({ uuid: this.uuid(), items: [] });
        this.setState({ claim: { ...this.state.claim, claims: claims } });
        this.touch();
    }

    removeChildClaim = (idx) => {
        Pop.showConfirm(`Are you sure you want to remove claim #${idx + 2}?`, 'Remove Claim', () => {
            let claims = this.state.claim.claims;
            claims.splice(idx, 1);
            this.setState({ claim: { ...this.state.claim, claims: claims } });
        });
        this.touch();
    }

    submit = async (e, autoSave) => {
        e?.preventDefault();
        if (!this.validated()) {
            this.alert('Please correct the errors before saving.');
            return;
        }
        try {
            let claim = { ...this.state.claim };
            if (claim.isReadyToSend)
                return;
            claim.visit.products.forEach(i => {
                i.productSize = String(i.productSize);
                delete i.entry;
            });
            this.setState({ changed: false });
            let j = await qreq.postAsync('/api/claim/save', claim);
            if (j.errorCode === 0) {
                if (!autoSave)
                    this.success('Claim updated successfully.');
            }
            else {
                if (autoSave)
                    this.alert('Error on Auto Save: ' + j.errorMessage);
                else
                    this.alert(j.errorMessage);
            }
        }
        catch (e) {
            if (autoSave)
                this.alert('Error on Auto Save: Unknown');
            else
                this.unkownErrorCallback();
            console.error(e);
        }
    }

    splitClaim = async () => {

    }

    transfer = (item, dstID, srcID) => {
        console.log('transfer', srcID, dstID);
        if (!dstID || !srcID || dstID === srcID)
            return;

        item.id = 0;
        if (dstID === 'main') {
            let items = [...this.state.claim.items];
            items.push(item);

            let src = this.state.claim.claims.find(i => i.uuid === srcID);
            let idx = src.items.findIndex(i => i.uuid === item.uuid);
            src.items.splice(idx, 1);
            this.setState({ claim: { ...this.state.claim, items: items } });
            this.touch();
            return;
        }

        let claims = [...this.state.claim.claims];
        let dstClaim = claims.find(i => i.uuid === dstID);
        console.log('dstClaim', dstID, dstClaim);
        let items = dstClaim.items;
        items.push(item);

        let claimItems = this.state.claim.items;

        if (srcID === 'main') {
            let idx = claimItems.findIndex(i => i.uuid === item.uuid);
            claimItems.splice(idx, 1);
        }
        else {
            let src = this.state.claim.claims.find(i => i.uuid === srcID);
            if (src) {
                let idx = src.items.findIndex(i => i.uuid === item.uuid);
                src.items.splice(idx, 1);
            }
        }

        this.setState({ claim: { ...this.state.claim, claims: claims, items: claimItems } });
        this.touch();
    }

    export = () => {
        window.open(`${Globals.serverUrl}/api/claim/report/pdf/${this.state.claim.id}/${this.state.claim.id}.pdf`, '_blank');
    }

    exportCMS1500 = () => {
        this.setState({ showExportCMS1500: true });
    }

    _exportCMS1500PDF = (i) => {
        window.open(`${Globals.serverUrl}/api/report/claim/cms1500/pdf/${i.id}.pdf`, '_blank');
    }

    change = () => {
        this.setState({ claim: this.state.claim });
        this.touch();
    }

    touch = () => {
        this.setState({ changed: true });
        this.validateItemChanges();
    }

    loadConstraints = async () => {
        await this.fillListAsync('/api/cptconstraint/list', 'cptConstraints');
    }

    validated = () => {
        if (this.state.errors.length > 0)
            return false;
        return true;
    }

    validateItemChanges = (claims) => {
        console.log('validateItemChanges', claims);
        if (!this.state.cptConstraints)
            return;
        if (!claims)
            claims = this.state.claim.claims;

        let errors = [];
        let items = [];



        claims.forEach(claim => {
            claim.items.forEach(item => {
                items.push(item);
            });
        });

        items.forEach(item => {
            let cpt = this.state.cptConstraints.find(i => i.code === item.code);
            if (cpt) {
                cpt.notAllowedCPTCodes.forEach(i => {
                    var check = items.find(j => j.code === i);
                    if (check)
                        errors.push(`CPT ${item.code} is not allowed with ${check.code}.`);
                });
            }
        });

        this.setState({ errors: errors });
    }

    toggleAutoSave = (e) => {
        if (e.target.checked) {
            this.toggleAutoSaveTimer(true);
            this.toggleAutoSaveSession(true);
        }
        else {
            clearInterval(this.autoSaveTimer);
            this.toggleAutoSaveTimer(false);
            this.toggleAutoSaveSession(false);
        }
    }

    toggleAutoSaveTimer = (set) => {
        if (set) {
            this.autoSaveTimer = setInterval(() => {
                if (this.state.changed)
                    this.submit(null, true);
            }, 5000);
        }
        else
            clearInterval(this.autoSaveTimer);
    }

    toggleAutoSaveSession = async (set) => {
        this.setState({ autoSave: set });
        try {
            await qreq.getAsync('/api/claim/autosave/toggle/set/' + (set ? 'true' : 'false'));
        }
        catch (e) {
            console.error(e);
        }
    }

    render() {
        return (
            <div className="container-fluid">
                <SplitModal show={this.state.showSplitModal} onHide={() => this.setState({ showSplitModal: false })} model={this.state.splitModel} onSplit={this.splitClaim} />
                <h1><L>Edit Claim</L></h1>
                <Modal show={this.state.showExportCMS1500} onHide={() => this.setState({ showExportCMS1500: false })}>
                    <Modal.Header>
                        <Modal.Title><L>Export Files</L></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ul className="list-group">
                            <li role="button" onClick={() => this._exportCMS1500PDF(this.state.claim)} className="list-group-item">
                                <Icon icon="faFilePdf" /> <span><L>Claim #1</L></span>
                            </li>
                            {this.state.claim?.claims?.map((i, idx) => <li key={idx} role="button" onClick={() => this._exportCMS1500PDF(i)}
                                className="list-group-item">
                                <Icon icon="faFilePdf" /> <span>Claim #{idx + 2}</span>
                            </li>)}
                        </ul>
                    </Modal.Body>
                    <Modal.Footer>
                        <OptionButton onClick={() => this.setState({ showExportCMS1500: false })}>
                            <L>Close</L>
                        </OptionButton>
                    </Modal.Footer>
                </Modal>
                <form onSubmit={this.submit}>
                    {this.state.claim && <>
                        <Card title="Claim Details">
                            <FormLabel model={this.state.claim.id} label="Claim ID" />
                            <FormLabel model={this.state.claim.order.oid} label="MRN" link={`/order/view/${this.state.claim.order.id}`} />
                            <FormLabel model={this.state.claim.order.practice.name} label="Practice" />
                            <FormLabel model={this.state.claim.order.provider.name} label="Provider" />
                            <FormLabel model={this.state.claim.order.accountName} label="Referring Account" />
                            <FormLabel model={this.state.claim.order.productName} label="Primary Product" />
                        </Card>
                        <div className="row">
                            <div className="col-md">
                                <Patient item={this.state.claim.patient} orderID={this.state.claim.order.id} title={this.T('subject')} readOnly requestContact requestAddress />
                            </div>
                            <div className="col-md">
                                <Insurance item={this.state.claim.insurance} />
                                <Card title="Visit" headerButtons={<Link to={`/visit/view/${this.state.claim.visit.id}`} className="btn btn-primary"><Icon icon="faCalendar" /> <L>View Visit</L></Link>}>
                                    <FormLabel model={Globals.toMDYHMLocalDateString(this.state.claim.visit.scheduleDate)} label="Date" link={`/visit/view/${this.state.claim.visit.id}`} />
                                    <FormInput model={this.state.claim} name="pos" label="Place of Service" type="select" options={this.state.posList} onChange={this.change} />
                                </Card>
                            </div>
                        </div>

                        <ClaimItemTable
                            id="main"
                            title="Claim Items"
                            claim={this.state.claim}
                            list={this.state.claim.items}
                            diagCodes={this.state.claim.diagCodes}
                            onToggle={this.change}
                            onAdd={(item) => this.addClaimItem(null, item)}
                            onRemove={this.onRemoveClaimItem}
                            transfer={this.transfer}
                        />

                        {this.state.claim.claims?.map((i, idx) => (
                            <ClaimItemTable
                                id={i.uuid}
                                key={idx}
                                title={`Claim #${idx + 2} Items`}
                                claim={i}
                                list={i.items}
                                diagCodes={this.state.claim.diagCodes}
                                onToggle={this.change}
                                onAdd={(item) => this.addClaimItem(i, item)}
                                onRemove={(idx) => this.onRemoveClaimItem(idx, i)}
                                onRemoveChild={() => this.removeChildClaim(idx)}
                                transfer={this.transfer}
                            />
                        ))}

                        <div className="text-center">
                            <button type="button" className="btn btn-secondary" onClick={this.addChildClaim}><Icon icon="faPuzzlePiece" /> <L>Add Claim</L></button>
                        </div>

                        <h2 className="text-center border-bottom my-5"><L>Source</L></h2>

                        {this.state.claim.visit?.id && <ClaimNotes visitID={this.state.claim.visit.id} examinationJsonData={this.state.claim.visit.examinationJsonData} />}

                        <ProductList visit={this.state.claim.visit} showPrice disabled />
                        <div className="row">
                            <div className="col-md-6">
                                <CPTCodeSelect disabled item={this.state.claim} title="CPT Codes" onChange={this.change} onToggle={this.change} />
                            </div>
                            <div className="col-md-6">
                                <DiagCodeSelect disabled item={this.state.claim} title="Diagnosis Codes" onChange={this.change} />
                            </div>
                        </div>
                        <h2 className="text-center border-bottom my-5"><L>Code Breakdown</L></h2>
                        <DiagCodeSelect disabled item={this.state.claim.order} title="Patient Diagnosis Codes" onChange={this.change} />
                        <DiagCodeSelect disabled item={this.state.claim.visit} title="Visit Diagnosis Codes" onChange={this.change} />
                        {this.state.claim.visit.wounds.map((wound, idx) => <div key={idx} className="row">
                            <div className="col-md-5 col-lg-3">
                                <Wound2 item={wound} title={`Wound ${idx + 1}`} />
                            </div>
                            <div className="col-md-7 col-lg-9">
                                <DiagCodeSelect disabled item={wound} title={`Wound ${idx + 1} Diagnosis Codes`} onChange={this.change} />
                            </div>
                        </div>)}
                    </>}
                    <AppActions>
                        <div className="d-flex justify-content-end">
                            <div className="text-center ms-3 me-3 mt-1 d-none d-md-block pt-2">
                                {this.state.errors.map((i, idx) => <span key={idx} className="text-danger">{i} </span>)}
                            </div>
                            <div className="d-flex justify-content-end">
                                <div className="pt-2 me-2 mt-1">
                                    <Switch checked={this.state.autoSave} onChange={this.toggleAutoSave} label={<><span className="d-none d-md-inline"><L>Auto Save</L></span><span className="d-inline d-md-none"><L>A-S</L></span></>} />
                                </div>
                                {this.state.claim && <Dropdown drop="up">
                                    <Dropdown.Toggle className="btn btn-primary btn-lg">
                                        <span className="d-none d-md-inline"><L>Actions</L></span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item className="d-none" onClick={() => this.setState({ showSplitModal: true })}><Icon icon="faArrowsSplitUpAndLeft" /> <L>Split</L></Dropdown.Item>
                                        <Dropdown.Item onClick={async () => await this.loadAsync()}><Icon icon="faRepeat" /> <L>Reset</L></Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.export()}><Icon icon="faFilePdf" /> <L>Export Claim PDF</L></Dropdown.Item>
                                        <Dropdown.Item onClick={() => this.exportCMS1500()}><Icon icon="faFilePdf" /> <L>Export CMS1500 PDF</L></Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>}
                                {this.state.claim && !this.state.claim.isReadyToSend && !this.state.autoSave
                                    && <button type="submit" className="btn btn-success btn-lg" disabled={!this.validated()}>
                                        <Icon icon="faSave" /> <span className="d-inline d-md-inline"><L>Save</L></span>
                                    </button>}
                            </div>
                        </div>
                    </AppActions>
                </form>
            </div>
        );
    }
}

export default withParamsAndNavigate(ClaimEdit);